<template>
    <div
        class="btn-add add-page"
        v-b-modal.add-pages-modal>
        {{ $t('magazine.add_pages') }}
        <b-modal
            id="add-pages-modal"
            :title="$t('magazine.new_pages')"
            :ok-disabled="!num_pages"
            :ok-title="$t('common.save')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            @ok="onOk()"
            modal-class="apprentice-default-modal">
            <b-form-group
                :label="$t('magazine.extra_pages')"
                label-for="add-page-input">
                <b-form-input
                    v-model="num_pages"
                    trim
                    type="number">
                </b-form-input>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-add-pages-component',
    props: ['magazineId'],
    data() {
        return {
            num_pages: 0,
        };
    },
    methods: {
        onOk() {
            const data = { num_pages: this.num_pages };
            this.alert.saving();

            this.axios.post(this.routes.magazineAddPages(this.magazineId), data).then(
                (response) => {
                    this.alert.success();
                    location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.add-page {
    justify-content: flex-start;

    &:before {
        width: 20px;
        color: $primary;
    }
}
</style>
